import React from 'react';
import { ParameterType, Type } from '../apiref/apireftypes';
import { ApiRef } from '../fasades/apiref';
import { explanTemperature } from '../endpoints/explanTemperature';
import { explainTopP } from '../endpoints/explainTopP';

export function createModelInfo() : ParameterType
{
    const desc = (<>
        <p>Contains information about a model, including its configuration, training parameters, and metadata.</p>
        </>);

    const temp = (<>
        <p>Default temperature setting, this is the value user in getResponse if no other value if specified.</p>
        { explanTemperature() }
        </>);

    const topP = (<>
        <p>Default temperature setting, this is the value user in getResponse if no other value if specified.</p>
        { explainTopP() }
        </>);

    return {
        id          : "ModelInfo",
        name        : "ModelInfo",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "name",
                "type"        : "string",
                "description" : <p>Model name, this is the name given to to model.</p>,
                "optional"    : false
            },
            {
                "name"        : "id",
                "type"        : "string",
                "description" : <p>Model id, this is a id generated when the model is created.</p>,
                "optional"    : false
            },
            {
                "name"        : "description",
                "type"        : "string",
                "description" : <p>Model description, set when the model was created.</p>,
                "optional"    : false
            },
            {
                "name"        : "read_only",
                "type"        : "boolean",
                "description" : <p>Is the model readonly, only the models that you have created can be trained(that is not read only)</p>,
                "optional"    : false
            },
            {
                "name"        : "parent_model",
                "type"        : "string",
                "description" : <p>The name of the parent model, this is the base model that the model is based on.</p>,
                "optional"    : true
            },
            {
                "name"        : "revision",
                "type"        : "number",
                "description" : <p>The revision number of the current model. It start with 0 and is increase by 1 for every training.</p>,
                "optional"    : true
            },
            {
                "name"        : "last_modified",
                "type"        : "number",
                "description" : <p>Time stamp of the latest training.</p>,
                "optional"    : true
            },
            {
                "name"        : "default_model",
                "type"        : "boolean",
                "description" : <p>The default model the one selected at startup.</p>,
                "optional"    : true
            },
            {
                "name"        : "temperature",
                "type"        : "number",
                "description" : temp,
                "optional"    : false
            },
            {
                "name"        : "top_p",
                "type"        : "number",
                "description" : topP,
                "optional"    : false
            },
            {
                "name"        : "learning_rate",
                "type"        : "number",
                "description" : <p>Default value for the learningRate used in <a href="/apiref/train">Training</a>.</p>,
                "optional"    : false
            },
            {
                "name"        : "learning_steps",
                "type"        : "number",
                "description" : <p>Default value for the learningSteps used in <a href="/apiref/train">Training</a>.</p>,
                "optional"    : false
            },
            {
                "name"        : "beta",
                "type"        : "number",
                "description" : <p>Default value for the beta used in <a href="/apiref/train">Training</a>.</p>,
                "optional"    : false
            },
            {
                "name"        : "epsilon",
                "type"        : "number",
                "description" : <p>Default value for the epsilon used in <a href="/apiref/train">Training</a>.</p>,
                "optional"    : false
            }
        ]
    };
}

export function createModelInfos() : ParameterType
{
    const childType = ApiRef.getType("ModelInfo");

    const desc = (<>
        <p>Contains all models available to the current use, both base models and models the you have created your self.</p>
        </>);

    return {
        id          : "ModelInfo[]",
        name        : "ModelInfos",
        description : desc,
        type        : Type.Array,
        childType   : childType
    };
}

